var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultBaseProps, defaultBaseCircleProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { getPathStyles, stripPercentToNumber, toArray } from './common';
var gradientSeed = 0;
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var _a = _this.props, percent = _a.percent, strokeColor = _a.strokeColor, trailColor = _a.trailColor, strokeWidth = _a.strokeWidth, gapDegree = _a.gapDegree, gapPosition = _a.gapPosition, strokeLinecap = _a.strokeLinecap, showInfo = _a.showInfo, children = _a.children, width = _a.width, style = _a.style, className = _a.className, restProps = __rest(_a, ["percent", "strokeColor", "trailColor", "strokeWidth", "gapDegree", "gapPosition", "strokeLinecap", "showInfo", "children", "width", "style", "className"]);
            var circleStyle = {
                width: width,
                height: width,
                fontSize: width * 0.15 + 6,
            };
            var svgStyle = {
                position: 'absolute',
            };
            var gradientId = (gradientSeed += 1);
            var percentList = toArray(percent);
            var strokeColorList = toArray(strokeColor);
            var gradient = strokeColorList.find(function (color) { return Object.prototype.toString.call(color) === '[object Object]'; });
            var getStokeList = function () {
                var stackPtg = 0;
                return percentList.map(function (ptg, index) {
                    var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
                    var stroke = Object.prototype.toString.call(color) === '[object Object]'
                        ? "url(#gradient-" + gradientId + ")"
                        : '';
                    var pathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition);
                    stackPtg += ptg;
                    return (React.createElement("path", { key: index, d: pathStyles.pathString, stroke: stroke, strokeLinecap: "round", strokeWidth: strokeWidth, opacity: ptg === 0 ? 0 : 1, fillOpacity: "0", style: pathStyles.pathStyle }));
                });
            };
            var _b = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition), pathString = _b.pathString, pathStyle = _b.pathStyle;
            var atomicsCircle = [
                'relative',
                'inline-flex',
                'justify-center',
                'items-center',
                'overflow-hidden',
            ];
            return (React.createElement(DivTag, __assign({ atomics: atomicsCircle, style: circleStyle, className: className }, restProps),
                React.createElement("svg", { viewBox: "0 0 100 100", style: svgStyle },
                    gradient && (React.createElement("defs", null,
                        React.createElement("linearGradient", { id: "gradient-" + gradientId, x1: "100%", y1: "0%", x2: "0%", y2: "0%" }, Object.keys(gradient)
                            .sort(function (a, b) { return stripPercentToNumber(a) - stripPercentToNumber(b); })
                            .map(function (key, index) { return (React.createElement("stop", { key: index, offset: key, stopColor: gradient[key] })); })))),
                    React.createElement("path", { className: "circle-trail", d: pathString, stroke: trailColor, strokeLinecap: "round", strokeWidth: strokeWidth, fillOpacity: "0", style: pathStyle }),
                    getStokeList().reverse()),
                children));
        };
        return _this;
    }
    Circle.defaultProps = Object.assign(defaultBaseProps, defaultBaseCircleProps);
    return Circle;
}(PureComponent));
export default Circle;
